const attributesObserver = (ele, callback) => {
    // sync all attrs on init
    Array.from(ele.attributes).forEach((attr) => callback(attr.name));
    const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
            if (mutation.type === 'attributes') {
                callback(mutation.attributeName);
            }
        });
    });
    observer.observe(ele, { attributes: true });
};

export { attributesObserver };
//# sourceMappingURL=helpers.js.map
